import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
	customField: {
		"&:hover $editButton": {
			display: "flex",
			minWidth: 18,
			padding: 0,
			height: 18,
			color: colors.gray[500]
		}
	},
	editButton: {
		display: "none"
	},
	editCustomFieldIcon: {
		minWidth: 18,
		padding: 0,
		height: 18
	},
	customFieldValueName: {
		paddingRight: 19
	},
	customFieldContainer: {
		padding: "32px 0px"
	},
	customFieldGroupNameSizeContainer: {
		width: "29%"
	},
	customFieldValueContainer: {
		width: "500px"
	},
	editCustomFieldButton: {
		height: 24,
		padding: 0,
		width: 24,
		paddingTop: 1
	}
}))

export default useStyles
